import { render, staticRenderFns } from "./CphWidget.vue?vue&type=template&id=b1577fd2&scoped=true&"
import script from "./CphWidget.vue?vue&type=script&lang=js&"
export * from "./CphWidget.vue?vue&type=script&lang=js&"
import style0 from "./CphWidget.vue?vue&type=style&index=0&id=b1577fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1577fd2",
  null
  
)

export default component.exports